// components/JourneyCard.jsx
import React from 'react';

const JourneyCard = ({ data, type, index, darkMode, onClick, cardRef }) => {
    
    const isFirstCard = index === 0;
    
    // Determine content keys based on type
    const titleKey = type === 'experience' ? 'title' : 'degree';
    const companyKey = type === 'experience' ? 'company' : 'institution';

    // Tailwind Classes
    const cardBaseClasses = `h-full rounded-xl p-6 cursor-pointer transform transition-all duration-500 ease-in-out group`;
    
    // Theme and Border
    const cardThemeClasses = darkMode 
        ? 'bg-card-light dark:bg-card-dark text-gray-100 hover:shadow-xl' 
        : 'bg-card-light dark:bg-card-dark text-gray-800 hover:shadow-xl';
    
    // Special border for the most recent card (index 0)
    const cardBorderClasses = isFirstCard
        ? 'border-4 border-primary' : '';

    const headingClasses = 'text-primary dark:text-secondary';

    // Text Colors
    const subtitleColor = darkMode ? 'text-info-400' : 'text-primary-600';
    const descriptionColor = darkMode ? 'text-gray-300' : 'text-gray-700';
    const mutedColor = darkMode ? 'text-gray-400' : 'text-gray-500';

    // Logo Styling
    const logoStyle = {
        width: '50px',
        height: '50px',
        objectFit: 'contain',
        padding: '5px',
        backgroundColor: darkMode ? '#333' : '#f8f9fa',
    };

    return (
        <div 
            className="col" 
            onClick={onClick} 
            ref={cardRef} 
            // Tailwind doesn't need style={position: 'relative'} on the wrapper if confetti is positioned absolutely relative to the section/parent element.
        >
            <div
                className={`${cardBaseClasses} ${cardThemeClasses} ${cardBorderClasses} ${isFirstCard ? 'relative' : ''}`}
                style={{
                    boxShadow: darkMode
                        ? '0 10px 20px rgba(0, 0, 0, 0.4)'
                        : '0 10px 20px rgba(0, 0, 0, 0.1)',
                }}
                // Custom hover effects are replaced with Tailwind utilities for simplicity
            >
                {/* Logo and Year/Company */}
                <div className="flex items-center mb-4">
                    <div className="me-4 flex-shrink-0">
                        <img
                            src={data.logo}
                            alt={data[companyKey]}
                            className="rounded-full"
                            style={logoStyle}
                        />
                    </div>
                    <div>
                        <h5 className={`text-lg font-semibold mb-0 ${headingClasses}`}> 
                            {data[companyKey]}
                        </h5>
                        <small className={`${mutedColor} text-sm`}>
                            {data.year}
                        </small>
                    </div>
                </div>
                
                {/* Title/Degree */}
                <h6 className={`text-base font-medium mb-3 ${subtitleColor}`}>
                    {data[titleKey]}
                </h6>
                
                {/* Description (Only for Experience) */}
                {type === 'experience' && (
                    <p className={`text-sm ${descriptionColor}`}>
                        {data.description}
                    </p>
                )}
                
                {/* Custom hover animation using Tailwind classes on group */}
                <div className="absolute inset-0 z-[-1] opacity-0 group-hover:opacity-100 transition-opacity duration-300 
                            group-hover:rotate-1 group-hover:scale-[1.03] 
                            rounded-xl pointer-events-none" 
                     style={{
                         backgroundImage: darkMode ? 'linear-gradient(to top right, rgba(0,0,0,0.1), rgba(0,0,0,0.4))' : 'linear-gradient(to top right, rgba(255,255,255,0.1), rgba(0,0,0,0.05))',
                         boxShadow: darkMode ? '0 15px 30px rgba(0,0,0,0.6)' : '0 15px 30px rgba(0,0,0,0.2)',
                     }}
                ></div>
            </div>
        </div>
    );
};

export default JourneyCard;